import { useEffect, useRef, useState } from 'react';
import FocusCard from './FocusCard';

const focusAreas = [
  {
    title: 'Data-First Brands',
    description: 'Visionary consumer brands that evolve intelligently through proprietary data — continuously refining products, experiences, and personalization to create deeper loyalty and exponential value (DTC, subscriptions, adaptive shopping).',
    icon: 'database'
  },
  {
    title: 'Connected Pet Intelligence',
    description: 'Pioneering technologies that weave seamless intelligence into everyday pet life — from wearables and trackers to IoT ecosystems, smart devices, and connected homes that capture real-time data and unlock new dimensions of care and understanding.',
    icon: 'wifi'
  },
  {
    title: 'AI & Data Intelligence Layer',
    description: 'Transformative intelligence systems that harvest, aggregate, and illuminate pet data across the ecosystem — powering preventive health, behavioral insight, wellness, risk models, and cross-industry breakthroughs through AI, APIs, analytics, and advanced data layers.',
    icon: 'brain'
  }
];

export default function FocusAreasSection() {
  const [visibleCards, setVisibleCards] = useState<boolean[]>(new Array(focusAreas.length).fill(false));
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.focus-card');
            cards.forEach((card, index) => {
              setTimeout(() => {
                card.classList.add('visible');
              }, index * 200);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-32 px-4 md:px-12 min-h-screen">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16 text-center">
          <h2 
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6"
            style={{ fontFamily: "'Orbitron', sans-serif" }}
          >
            Our Focus Areas
          </h2>

          <p 
            className="text-lg md:text-xl text-gray-600 max-w-[680px] mx-auto"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            We back transformative innovations shaping the next era of the human-pet bond.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {focusAreas.map((area, index) => (
            <FocusCard
              key={index}
              title={area.title}
              description={area.description}
              icon={area.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
